import { render, staticRenderFns } from "./org_quick_view.vue?vue&type=template&id=0cebf572&scoped=true"
import script from "./org_quick_view.vue?vue&type=script&lang=js"
export * from "./org_quick_view.vue?vue&type=script&lang=js"
import style0 from "./org_quick_view.vue?vue&type=style&index=0&id=0cebf572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebf572",
  null
  
)

export default component.exports